module.exports = "<div  v-bind:class=\"{ 'mt-1': hasMargin }\" v-bind:style=\"{ height: coHeight }\"  >\n  <ContentLoader v-if=\"coHeightISString\" :primaryColor=\"dtPalette['grey-3']\" >\n    <rect x=\"0\" y=\"0\" :rx=\"dt_radius\" :ry=\"dt_radius\" :width=\"width\" :height=\"400\" />\n  </ContentLoader>\n  <ContentLoader v-else :primaryColor=\"dtPalette['grey-3']\" >\n    <rect x=\"0\" y=\"0\" :rx=\"dt_radius\" :ry=\"dt_radius\" :width=\"width\" :height=\"coHeight\" />\n  </ContentLoader>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/block/loaders/block-infos-loader/template.html
// module id = hfjm
// module chunks = 0